import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-[#000000] py-6 md:py-8 px-4 border-t border-gray-800" data-id="element-138">
      <div className="max-w-xl mx-auto text-center" data-id="element-139">
        <div className="bg-gray-900 rounded-xl p-5 md:p-6 border border-green-500/30 shadow-[0_0_20px_rgba(34,197,94,0.1)] relative overflow-hidden" data-id="element-140">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-600 to-green-400" data-id="element-141"></div>
          <h2 className="text-xl md:text-2xl font-black font-heading text-white mb-4" data-id="element-142">
            🛡️ Garantía 7 días sin preguntas
          </h2>
          <div className="flex flex-col sm:flex-row justify-center gap-2 mb-4 text-left max-w-sm mx-auto" data-id="element-143">
            <div className="flex items-center gap-2 bg-gray-800/50 p-2 rounded-lg border border-gray-700/50 flex-1" data-id="element-144">
              <div className="bg-green-500/20 border border-green-500/50 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0" data-id="element-145">
                <span className="text-green-400 font-bold text-xs" data-id="element-146">1</span>
              </div>
              <p className="text-gray-300 font-body text-xs" data-id="element-147">Abres los tomos</p>
            </div>
            <div className="flex items-center gap-2 bg-gray-800/50 p-2 rounded-lg border border-gray-700/50 flex-1" data-id="element-148">
              <div className="bg-green-500/20 border border-green-500/50 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0" data-id="element-149">
                <span className="text-green-400 font-bold text-xs" data-id="element-150">2</span>
              </div>
              <p className="text-gray-300 font-body text-xs" data-id="element-151">
                Revisas los bonos
              </p>
            </div>
            <div className="flex items-center gap-2 bg-gray-800/50 p-2 rounded-lg border border-gray-700/50 flex-1" data-id="element-152">
              <div className="bg-green-500/20 border border-green-500/50 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0" data-id="element-153">
                <span className="text-green-400 font-bold text-xs" data-id="element-154">3</span>
              </div>
              <p className="text-gray-300 font-body text-xs" data-id="element-155">Lo aplicas</p>
            </div>
          </div>
          <div className="bg-green-900/20 rounded-lg p-4 border border-green-500/30" data-id="element-156">
            <p className="text-sm md:text-base font-bold text-white font-heading mb-1" data-id="element-157">
              Si en 7 días no es lo que esperabas:
            </p>
            <p className="text-lg md:text-xl font-black text-green-400 font-heading mb-1.5" data-id="element-158">
              👉 Te devolvemos el 100%
            </p>
            <p className="text-gray-400 font-body text-xs font-medium" data-id="element-159">
              Sin preguntas. Sin vueltas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}